import React, { useState } from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import { Button, Card, Col, Container, Row, Form } from "react-bootstrap";
import Like from '../assets/images/like.svg'
import Img1 from '../assets/images/buy/img-1.png'
import Img2 from '../assets/images/buy/img-2.png'
import Img3 from '../assets/images/buy/img-3.png'
import Img4 from '../assets/images/buy/img-4.png'
import Img5 from '../assets/images/buy/img-5.png'
import bed from '../assets/images/bed.svg'
import bath from '../assets/images/bath.svg'
import size from '../assets/images/scale.svg'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";


function RecentlyViewed() {
   const listings = [
      {
        id: 1,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img1, Img2, Img3],
        tag: "House for sale",
        showButton: false,
      },
      {
        id: 2,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img4, Img5, Img1],
        tag: "House for sale",
        showButton: false,
      },
       {
        id: 3,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img4, Img5, Img1],
        tag: "House for sale",
        showButton: false,
      },
       {
        id: 4,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img4, Img5, Img1],
        tag: "House for sale",
        showButton: true,
      },
       {
        id: 5,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img1, Img2, Img3],
        tag: "House for sale",
        showButton: true,
      },
      {
        id: 6,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img4, Img5, Img1],
        tag: "House for sale",
        showButton: true,
      },
       {
        id: 7,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img4, Img5, Img1],
        tag: "House for sale",
        showButton: false,
      },
       {
        id: 8,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img4, Img5, Img1],
        tag: "House for sale",
        showButton: false,
      },
       {
        id: 9,
        price: "$3,650,000",
        address: "529 Clinton Avenue, Rockville Centre, NY 11570",
        beds: 3,
        baths: 2,
        size: 600,
        imgs: [Img4, Img5, Img1],
        tag: "House for sale",
        showButton: false,
      }
    ];
  
    const [favorites, setFavorites] = useState(() => new Set());

    const toggleFavorite = (key) => {
      setFavorites((prev) => {
        const s = new Set(prev);
        if (s.has(key)) s.delete(key);
        else s.add(key);
        return s;
      });
    };
  return (
    <>
      <div className="main saved-homes-page">
        <Header />
        <CommonBanner title="Recently Viewed" />
        <section className="saved-homes-section common-padding">
          <Container>
            <Row className="row-gap-4">
              {listings.map((item) => (
                <Col md={6} lg={4} key={item.id}>
                  <div className="property-box">
                    <div className="result-item-img position-relative">
                      <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={20}
                        centeredSlides={true}
                        slidesPerGroup={1}
                        // loop={true}
                        // autoplay={{ delay: 2500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                      >
                        {item.imgs.map((imgSrc, idx) => (
                          <SwiperSlide key={idx}>
                            <Card className="border-0">
                              <Card.Img src={imgSrc} />
                            </Card>
                          </SwiperSlide>
                        ))}
                      </Swiper>

                      {item.tag && (
                        <span className="recommended">{item.tag}</span>
                      )}

                      <span
                        role="button"
                        tabIndex={0}
                        className={`wishlist ${
                          favorites.has(item.id) ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleFavorite(item.id);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") toggleFavorite(item.id);
                        }}
                      >
                        <img src={Like} alt="like" />
                      </span>
                    </div>
                    <div className="result-item-info">
                      <h2>{item.price}</h2>
                      <p>{item.address}</p>
                      <div className="info-box">
                        <span>
                          <img src={bed} alt="" /> {item.beds}
                        </span>
                        <span>
                          <img src={bath} alt="" /> {item.baths}
                        </span>
                        <span>
                          <img src={size} alt="" /> {item.size}
                        </span>
                      </div>
                       {item.showButton ? (
                        <Button className="custom-bttn style-2 w-100 mt-3">
                          Request a tour
                        </Button>
                      ) : (
                        <h6>MLS ID #25-835, HILL REAL ESTATE GROUP, LLC</h6>
                      )}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
}
export default RecentlyViewed;
